export type Currency = string;

export enum CurrencyOld {
  CHF = 'CHF',
  EUR = 'EUR',
}

export interface CurrencyDto {
  name: string;
  isoCode: string;
  isoNumber: number;
  icon?: string;
}